import { Theme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import Profile from './Profile';
import { FC } from 'react';
import LogoMain from '../../../../components/logo/LogoMain';

const HeaderContent: FC = () => {
	const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

	return (
		<>
			{downLG && <LogoMain />}

			<Profile />
		</>
	);
};

export default HeaderContent;
